import styled from "styled-components";

export const SyncedIcon = styled.div`
  font-weight: bold;

  .synced {
    color: ${(props) => props.theme.palette["darkGreen"]};
  }

  .notSynced {
    color: ${(props) => props.theme.palette["redSecondary"]};
  }
`;

export const StatusIcon = styled.div`
  svg {
    font-weight: bold;
    font-size: 1.8rem;
  }

  .activeContract {
    color: ${(props) => props.theme.palette["green"]};
  }

  .cancelledContract {
    color: ${(props) => props.theme.palette["redSecondary"]};
  }

  .suspendedContract {
    color: ${(props) => props.theme.palette.light["purple"]};
  }
`;
